// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UVy4T","right":"styles_right__mSuXg"};